// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The container */
.styles_container__jBiGM {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
  height: 20px !important;
}

/* Hide the browser's default checkbox */
.styles_container__jBiGM input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.styles_checkmark__uEjzE {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  /* Gray / gray-1 */
  /* Gray / gray-5 */
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.styles_container__jBiGM:hover input ~ .styles_checkmark__uEjzE {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
/* Create the checkmark/indicator (hidden when not checked) */
.styles_checkmark__uEjzE:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.styles_container__jBiGM input:checked ~ .styles_checkmark__uEjzE:after {
  display: block;
}

/* Style the checkmark/indicator */
.styles_container__jBiGM .styles_checkmark__uEjzE:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.styles_container__jBiGM .styles_checkmark__uEjzE::before {
  border: 2px solid #000;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/CheckBox/styles.module.scss"],"names":[],"mappings":"AAAA,kBAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EAEA,eAAA;EACA,eAAA;EAIA,iBAAA;EACA,uBAAA;AAAF;;AAGA,wCAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAAF;;AAGA,6BAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAEA,kBAAA;EAGA,kBAAA;EAEA,oCAAA;EAEA,kBAAA;AALF;;AAQA,+CAAA;AACA;EACE,sBAAA;AALF;;AAQA,wDAAA;AAKA,6DAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AATF;;AAYA,oCAAA;AACA;EACE,cAAA;AATF;;AAYA,kCAAA;AACA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,wBAAA;AATF;;AAYA;EACE,sBAAA;AATF","sourcesContent":["/* The container */\n.container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  // margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  height:20px !important;\n}\n\n/* Hide the browser's default checkbox */\n.container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  // background-color: #eee;\n  /* Gray / gray-1 */\n\n  // background: #FFFFFF;\n  /* Gray / gray-5 */\n\n  border: 1px solid rgba(0,0,0,0.5);\n  // border-radius: 2px;\n  border-radius: 50%;\n}\n\n/* On mouse-over, add a grey background color */\n.container:hover input~.checkmark {\n  background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n.container input:checked~.checkmark {\n  // background-color: #d8000d;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.container input:checked~.checkmark:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.container .checkmark:after {\n  left: 9px;\n  top: 5px;\n  width: 5px;\n  height: 10px;\n  border: solid #000;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.container .checkmark::before{\n  border:2px solid #000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__jBiGM`,
	"checkmark": `styles_checkmark__uEjzE`
};
export default ___CSS_LOADER_EXPORT___;
